import { useBlockProps, RichText } from '@wordpress/block-editor';

export default function save(props) {
	const blockProps = useBlockProps.save({
		className: 'c4l-do-dont-cards',
	});

	const { attributes } = props;
	const { contentDo, contentDont } = attributes;

	return (
		<div {...blockProps}>
			<RichText.Content
				tagName='div'
				className='c4l-do-dont-cards-do'
				value={contentDo}
			/>
			<RichText.Content
				tagName='div'
				className='c4l-do-dont-cards-dont'
				value={contentDont}
			/>
		</div>
	);
}
